<template>
  <div class="shopdetails-box">
    <div v-if="permissionsTalg">
      <!--面包屑区域-->
      <div class="breadcrumb_box" v-if="!isAlibabaDistributor">
        <span class="breadcrumb_title">{{ $t('key1006739') }}</span>
        <Breadcrumb separator=">">
          <BreadcrumbItem v-for="(item,index) in breadcrumbList" :key="index" :to="changeBreadcrumb(item)">{{ item.title }}</BreadcrumbItem>
        </Breadcrumb>
      </div>
      <div v-if="details">
        <!--商品展示区域-->
        <div class="exhibition-box">
          <div class="exhibition-left">
            <img-zoom ref="imgBox" :imgZoomList="imgZoomList" :details="details"></img-zoom>
          </div>
          <div class="exhibition-right">
            <div class="flex flex-wrap mb8">
              <h2 class="exhibition-title" :title="details.name">{{ details.name }}</h2>
              <template v-if="details.productTagList.length >0 && showProductTagInMall">
                <span class="productTag_item" v-for="name in details.productTagList" :title="name">{{ name }}</span>
              </template>
            </div>
            <div class="grounding-box">
              <span :class="systemEnvironment === 'yms' ? 'text' : 'trsText'">SPU：{{ details.ymsSpu }}</span>
              <span :class="systemEnvironment === 'yms' ? 'text' : 'trsText'">SKU：{{ commodityDetails.ymsSku }}</span>
            </div>
            <div class="grounding-box" v-if="systemEnvironment === 'yms'">
              <span class="text">{{ $t('key1006740') }}{{ $uDate.dealTime(details.createdTime, 'fulltime') }}</span>
              <span class="text">{{ $t('key1000945') }}{{ details.deliveryInterval + $t('key1001631') }}</span>
              <span class="text">{{ $t('key1000944') }}{{ details.productServiceTxt }}</span>
            </div>
            <!--发货地-->
            <div class="grounding-box" v-if="systemEnvironment === 'yms'">
              <div class="flex align-items-center">
                <span class="color-333 font-weight-bold">{{ $t('key1002433') }}</span>
                <Select size="small" v-model="placeOfShipment" class="width_150" @on-change="deliveryLocationChange" transfer>
                  <Option v-for="item in placeOfShipmentList" :key="item.ymsDeliveryPlaceId" :value="item.ymsDeliveryPlaceId">{{ item.deliveryPlaceName }}</Option>
                </Select>
              </div>
            </div>
            <!--发货仓-->
            <div class="flex align-items-start mt10 mb10" v-if="systemEnvironment === 'yms'">
              <span class="color-333 font-weight-bold" style="position: relative; top: 2px;">{{ $t('key1001227') }}</span>
              <RadioGroup v-model="shippingWarehouse" class="shippingWarehouse_box" @on-change="shippingWarehouseChange">
                <Radio v-for="item in shippingWarehouseList" :label="item.ymsWarehouseId" class="shippingWarehouse_item">
                  <div class="flex align-items-center">
                    <span class="font-size-12">{{ item.name }}</span>
                    <Button size="small" type="primary" class="ml5">
                      <span class="display-inline-block mr5">{{ item.warehouseType === 1 ? $t('key1002589') : $t('key1006734') }}</span>
                      <Tooltip transfer placement="top" max-width="500" :content="item.warehouseType === 1 ?
                            $t('key1006730') : $t('key1006731')">
                        <Icon class="help_icon" size="17" type="md-alert"></Icon>
                      </Tooltip>
                    </Button>
                  </div>
                </Radio>
              </RadioGroup>
            </div>
            <!--规格-->
            <div v-for="(item,idx) in newProductGoodsList" class="mb15" v-if="systemEnvironment === 'yms'">
              <div class="flex align-items-center mb5">
                <h3 class="font-size-14 color-333 font-weight-bold">{{ item.name }}</h3>
                <span class="color-666 ml4 font-size-13">{{ '(' + item.selectValue + ')' }}</span>
              </div>
              <div class="flex flex-wrap" v-if="item.isMainAttribute === 1">
                <div
                  v-for="(ele, ids) in item.values"
                  class="specificationImage_box"
                  :title="ele.isDisabled ? $t('key1006732') : ''"
                  :class="ele.isDisabled ? 'specificationImageDisabled' : ids === item.currentIndex && !ele.isDisabled ? 'specification_active' : ''">
                  <img class="img_style_item" :src="setImgPath(ele.imgPath, null, '70x70', null, true)"
                    alt="" @click="selectSpecifications('primaryAttribute', idx, ids, ele)">
                </div>
              </div>
              <div class="flex flex-wrap" v-else>
                <span
                  v-for="(ele,ids) in item.values" @click="selectSpecifications('current', idx, ids, ele)"
                  class="specificationValue_box"
                  :title="ele.isDisabled ? $t('key1006732') : ''"
                  :class="ele.isDisabled ? 'specificationValueDisabled' : ids === item.currentIndex ? 'specification_active' : ''">
                  {{ ele.value }}
                </span>
              </div>
            </div>
            <!--数量-->
            <template v-if="systemEnvironment === 'yms'">
              <div class="flex align-items-center mb15">
                <h3 class="font-size-14 color-333 font-weight-bold">{{ $t('key1005987') }}</h3>
                <div class="quantityOfGoods_box">
                  <button :disabled="quantityOfGoods <= 1" :style="quantityOfGoods <= 1 ?  {color: '#E6E6E6'} : ''"
                    @click="quantityBtn('minus')" class="quantity_btn">－</button>
                  <input type="text" v-model="inputValue" @input="validateInput" class="quantity_input_box"/>
                  <button @click="quantityBtn('add')" class="quantity_btn">＋</button>
                </div>
                <span class="distributorThemeColor ml8">{{ $t('key1006443') + totalWeight }}g</span>
                <template v-if="userInfo">
                  <span class="distributorThemeColor ml30" v-if="!isStopSale">{{ $t('key1003367') + commodityInventory }}</span>
                  <span class="distributorThemeColor ml30">
                    {{ $t('key1006735') + commodityDetails.length + ' * ' + commodityDetails.width + ' * ' + commodityDetails.height }}
                  </span>
                </template>
                <template v-else>
                  <span class="distributorThemeColor ml50 mr8">{{ $t('key1006741') }}</span>
                </template>
              </div>
            </template>
            <template v-else>
              <p class="trsThemeColor mb15">{{ $t('key1006443') + totalWeight }}g</p>
              <template v-if="userInfo">
                <p class="trsThemeColor mb15" v-if="!isStopSale">{{ $t('key1003367') + commodityInventory }}</p>
                <p class="trsThemeColor mb15">
                  {{ $t('key1006735') + commodityDetails.length + ' * ' + commodityDetails.width + ' * ' + commodityDetails.height }}
                </p>
              </template>
              <template v-else>
                <span class="trsThemeColor">{{ $t('key1006741') }}</span>
              </template>
              <div class="flex align-items-center mb15">
                <h3 class="font-size-14 color-333 font-weight-bold">{{ $t('key1005987') }}</h3>
                <div class="quantityOfGoods_box">
                  <button :disabled="quantityOfGoods <= 1" :style="quantityOfGoods <= 1 ?  {color: '#E6E6E6'} : ''"
                    @click="quantityBtn('minus')" class="quantity_btn">－</button>
                  <input type="text" v-model="inputValue" @input="validateInput" class="quantity_input_box"/>
                  <button @click="quantityBtn('add')" class="quantity_btn">＋</button>
                </div>
              </div>
            </template>
            <!--价格-->
            <div class="price_box">
              <template v-if="userInfo">
                <span class="amount">{{ totalPriceOfGoods }}</span>
                <span class="currency">{{ '(' + currencyState + ')' }}</span>
              </template>
              <template v-else>
                <span class="distributorThemeColor">{{ $t('key1006742') }}</span>
              </template>
            </div>
            <!--优惠区域-->
            <div class="discount" v-if="details.productPriceSchemeResultBos && systemEnvironment === 'yms'">
              <div class="dis-box">
                <p class="d-item">{{ $t('key1006743') }}</p>
                <p>{{ $t('key1006744') }}</p>
              </div>
              <div class="dis-box" v-for="item in details.productPriceSchemeResultBos">
                <p class="d-item">
                  <span class="ic" v-if="item.schemeType === 1">{{ item.schemeValue !== null ? Math.round(item.schemeValue * 100) / 10 : '*' }}{{ $t('key1006745') }}</span>
                  <span class="ic" v-else>
                  {{ $t('key1006746') }}
                  {{ item.schemeValue !== null ? Math.round(item.schemeValue * 100) / 100 : '*' + ' ' + (currencyState ? currencyState : '') }}
                </span>
                  <Tooltip :content="$t('key1006733')" v-if="!item.schemeValue" transfer>
                    <Icon type="md-help-circle" class="icon"/>
                  </Tooltip>
                </p>
                <p>
                <span v-if="item.endSalesVolume">
                  {{ item.startSalesVolume }} - {{ item.endSalesVolume }}{{ $t('key1005126') }}
                </span>
                  <span v-else>
                  {{ item.startSalesVolume }}{{ $t('key1006747') }}
                </span>
                </p>
              </div>
            </div>
            <!--目的地-->
            <div class="flex mb15" style="align-items: normal;">
              <Select class="destination_box" v-model="destinationValue" filterable style="width: 180px;"
                @on-change="destinationChange" @on-open-change="destinationVisibleChange">
                <div class="flex align-items-center justify-content-between mb8 pl15" slot="prefix">
                  <span class="title">{{ $t('key1004276') }}</span>
                  <Icon :type="destinationVisible ? 'md-arrow-dropup' : 'md-arrow-dropdown'" color="#949494" size="22"/>
                </div>
                <Option v-for="item in destinationCountryList" :value="item.twoCode" :key="item.twoCode">{{ item.name }}</Option>
              </Select>
              <!--物流方式-->
              <Dropdown class="logisticsMethod_box" style="width: 550px;" trigger="click" @on-click="selectedLogisticsMethod"
                @on-visible-change="logisticsMethodVisibleChange">
                <div class="flex align-items-center justify-content-between mb8">
                  <span class="title">{{ $t('key1003840') }}</span>
                  <Icon :type="logisticsDropdownVisible ? 'md-arrow-dropup' : 'md-arrow-dropdown'" color="#949494" size="22"/>
                </div>
                <div class="wid100P">
                  <template v-if="Object.keys(logisticsMethods).length>0">
                    <div class="wid100P flex font-size-14 mb4">
                      <div class="setlabelName flex align-items-center">
                        <span class="labelTxt font-size-13" :title="logisticsMethods.name">{{ logisticsMethods.name }}</span>
                        <span class="smallDot"></span>
                      </div>
                      <div class="distributorThemeColor mr5 font-size-13" style="flex:1;">
                        <span class="mr15">{{ $t('key1006736') + logisticsMethods.minEfficiency + ' - ' + logisticsMethods.maxEfficiency }}</span>
                        <span v-if="logisticsMethods.postalCodeData.length<=0">
                            {{ $t('key1006737') + currencyState + ')：' + logisticsMethods.estimateFreightPrice }}
                          </span>
                      </div>
                    </div>
                    <template v-if="logisticsMethods.postalCodeData.length>0">
                      <template v-for="(ele, ids) in logisticsMethods.postalCodeData">
                        <p class="felx align-items-center font-size-12">
                          <span v-if="ids === 0 || ele.expand" class="color-999 mr20 ellipsis_1" :title="ele.postalCode">{{ $t('key1006738') + '(' + ele.postalCode + ')' }}</span>
                          <span v-if="ids === 0 || ele.expand" class="distributorThemeColor mr20">{{ $t('key1006737') + currencyState + ')：' + ele.shippingCost }}</span>
                          <span v-if="ids === 0 && logisticsMethods.postalCodeData.length >1" class="cursor"
                            style="color: #00B42A; z-index: 10" @click.stop="logisticsMethodExpand(ids)">
                              {{ ele.expand ? $t('key1006351') : $t('key1000141') }}
                            </span>
                        </p>
                      </template>
                    </template>
                  </template>
                  <span v-else class="title">{{ $t('key1006748') }}</span>
                </div>
                <DropdownMenu slot="list">
                  <DropdownItem v-for="item in logisticsMethodData" :name="item.ymsLogisServiceId" class="logisticsMethod_box_item">
                    <div class="flex">
                      <div class="setlabelName flex align-items-center">
                        <span class="labelTxt font-size-13">{{ item.name }}</span>
                        <span class="smallDot"></span>
                      </div>
                      <div class="distributorThemeColor font-size-13" style="flex: 1">
                        <span class="mr15">{{ $t('key1006736') + item.minEfficiency + ' - ' + item.maxEfficiency }}</span>
                        <span :style="item.postalCodeData.length > 0 ? {visibility: 'hidden'} : ''">
                            {{ $t('key1006737') + currencyState + ')：' + item.estimateFreightPrice }}
                          </span>
                      </div>
                    </div>
                    <template v-if="item.postalCodeData.length>0">
                      <div class="flex">
                        <div class="setlabelName flex align-items-center"></div>
                        <p class="felx align-items-center mt3 font-size-12" v-for="(ele,idx) in item.postalCodeData">
                          <span class="color-999 mr20 postalCodeStyle" :title="ele.postalCode" v-if="idx === 0">
                            {{ $t('key1006738') + '(' + ele.postalCode + ')' }}
                          </span>
                          <span class="distributorThemeColor mr20" v-if="idx === 0">
                            {{ $t('key1006737') + currencyState + ')：' + ele.shippingCost }}
                          </span>
                          <span v-if="item.postalCodeData.length>1 && idx === 0">......</span>
                        </p>
                      </div>
                    </template>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            <!--操作按钮-->
            <div class="opts-box">
              <template v-for="item in optionsList">
                <template v-if="item.imgIcon">
                  <Button class="subscribe-btn" type="primary" :ghost="item.mainButtonValue === 0"
                    :disabled="isStopSale" @click="optionsBtn(item)">
                    <div class="flex align-items-center">
                      <img :src="skilledHand_logo" width="32" height="32" alt="">
                      <span class="ml5">{{ item.buttonName }}</span>
                    </div>
                  </Button>
                </template>
                <Button v-else class="subscribe-btn" type="primary" :ghost="item.mainButtonValue === 0"
                  :disabled="isStopSale" @click="optionsBtn(item)">
                  {{ item.buttonName }}
                </Button>
              </template>
              <template v-if="moreOptionsList.length >0">
                <Dropdown transfer @on-click="moreOptionsBtn">
                  <Button class="more-subscribe-btn" type="primary" ghost>
                    <span>{{ $t('key1000106') }}</span>
                    <Icon type="ios-arrow-down"></Icon>
                  </Button>
                  <DropdownMenu slot="list">
                    <DropdownItem v-for="item in moreOptionsList" :disabled="isStopSale" :name="item.paramKey">
                      {{ item.buttonName }}
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </template>
              <!--只有已上架的商品才能收藏和下载资料-->
              <template v-if="details.hasPermission">
                <!--未收藏-->
                <div class="opts-box" v-if="(details.isSubscription === 0 && getPermission('ymsDistributorMerchantSubscription_subscription')
                 && userInfo) || (details.isSubscription === 0 && (!userInfo || fromListing))">
                  <Icon type="md-heart-outline" size="32" :class="!isStopSale ? 'cursor' : 'cursor-not-allowed'" @click="subscription"/>
                  <span class="ml4">{{ $t('key1006749') }}</span>
                </div>
                <!--已收藏-->
                <div class="opts-box" v-if="(details.isSubscription !== 0 && getPermission('ymsDistributorMerchantSubscription_cancelSubscription')
                 && userInfo) || (details.isSubscription !== 0 && (!userInfo || fromListing))">
                  <Icon type="md-heart" size="30" color="#FF5310" :class="!isStopSale ? 'cursor' : 'cursor-not-allowed'" @click="unSubscription"/>
                  <span class="ml4">{{ $t('key1005703') }}</span>
                </div>
              </template>
            </div>
            <!--一键刊登支持以下平台-->
            <div class="support_platform_content" v-if="details.availablePlatforms && details.availablePlatforms.length >0">
              <h3 class="title">{{ $t('key1006750') }}</h3>
              <ul class="support_platform_box">
                <li class="platformIcon" v-for="(item, index) in details.availablePlatforms" :key="index">
                  <div class="support_platform_item">
                    <img :src="item.iconPath" width="53.5" height="21" alt="">
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--定制商品详情-->
        <div class="back-fff p16 mb15 position-relative" v-if="customizedProductsData.length >0">
          <Table
            :disabled-hover="true"
            :highlight-row="false"
            max-height="400"
            :loading="tableLoading"
            :columns="customizedProductsColumns"
            :data="customizedProductsData">
            <template #locationDiagram="{row, index}">
              <div class="imgagesList_box" v-viewer="viewerOptions">
                <div class="imgagesList_box_item" v-for="(item,idx) in row.ymsProductGoodsPositionImageList" :key="idx">
                  <div class="img_content">
                    <img class="img-styles" :src="setImgPath(item.path, null, null, null, false)"
                      @error="setErrorImg($event)" alt=""/>
                  </div>
                </div>
              </div>
            </template>
          </Table>
          <span class="customDesign_btn" @click="customizedButton"
            v-if="Object.keys(userInfo).length > 0 && getPermission('ymsDistributorProductInfo_createCustomizationGoods')
                 && details.isSupportCustomization === 1 || !userInfo">
            {{ $t('key1006751') }}
          </span>
        </div>
        <!--商品详情信息-->
        <div class="shopping-content">
          <div class="shop-content-nav">
            <!--优质供应商  TE-30731 需求调整，先暂时屏蔽-->
            <!--            <div class="quality-supplier-box" v-if="!fromListing && Object.keys(supplierInfo).length >0">
              <div class="title-box">
                <span :class="languagesVal === 'zh-CN' ? 'title' : 'set_title'">优质供应商</span>
              </div>
              <h3 class="supplier-title" :title="supplierInfo.name">{{ supplierInfo.name }}</h3>
              <p class="line-item" v-if="!isAlibabaDistributor">{{ '地址：' + supplierInfo.address }}</p>
              <div class="options-btn" v-if="!isAlibabaDistributor">
                <Button size="small" class="btn" @click="toStoreList">进入店铺</Button>
                <Button size="small" class="btn" @click="followStore" :disabled="followTalg">{{ followText }}</Button>
              </div>
            </div>-->
            <!--销量最高的三个商品-->
            <div class="top3-box-item" v-for="(item, index) in supplierTop3List" :key="index" @click="toshopDetails(item)">
              <div class="img-style">
                <imageBox :src="getThumbnailImage(item.primaryImage)" :animation="true"/>
              </div>
              <h3 class="title" :title="item.name">{{ item.name }}</h3>
              <p class="text" v-if="userInfo">
                <span v-if="item.activityStatus === 1 || item.activityStatus === 3">{{ currencyState + amountHandel(item.activityPrice) }}</span>
                <span class="original_price_style" v-if="item.activityStatus === 1 || item.activityStatus === 3">{{ currencyState + amountHandel(item.minSuggestPrice) }}</span>
                <span v-else>{{ currencyState + ' ' + amountHandel(item.minSuggestPrice) }}</span>
              </p>
              <p class="text" v-else>{{ $t('key1006752') }}</p>
              <!--已收藏-->
              <span class="subscribed-icon" v-if="item.subscribed" style="background-color: #8FC41E;">{{ $t('key1005507') }}</span>
              <!--清仓-->
              <span :class="item.subscribed ?'clearance-icon': 'subscribed-icon'" v-if="item.activityStatus === 1"
                style="background-color: #FF1810;">{{ $t('key1001114') }}</span>
            </div>
          </div>
          <!--商品详细信息-->
          <div class="shop-details-box">
            <h2 class="shop-details-title">{{ $t('key1006753') }}</h2>
            <!--物品参数-->
            <div class="desc-box" v-if="ymsCategoryProductAttributeList && ymsCategoryProductAttributeList.length">
              <p class="desc-box-title">{{ $t('key1006754') }}</p>
              <Row>
                <Col :span="12" v-for="(item, index) in ymsCategoryProductAttributeList" :key="index">
                  <div class="desc-box-item">
                    <p class="desc-box-item-title">{{ item.name + '：' }}</p>
                    <p class="desc-box-content">
                      <template v-for="(ele,idx) in item.valueText">
                        <span v-if="ele.proportion" class="mr2">{{ handleAttributeProportion(ele.proportion) + '%' }}</span>
                        <span>{{ ele.value }}</span>
                        <span v-if="ele.unit" class="mr2">{{ handleattributeUnit(item, ele.unit) }}</span>
                        <span v-if="idx !== item.valueText.length - 1">、</span>
                      </template>
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
            <!--尺码表-->
            <div class="desc-box" v-if="sizeImagePath">
              <p class="desc-box-title">{{ $t('key1000978') }}</p>
              <div class="size-chart-box">
                <img :src="sizeImagePath" class="szieImage" alt="">
              </div>
            </div>
            <!--供应商建议-->
            <div class="desc-box" v-if="details.description">
              <p class="desc-box-title">{{ $t('key1006755') }}</p>
              <div class="shop-details-center" v-html="details.description"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="center-align">
        <Spin>
          <Icon type="ios-loading" size=30 class="demo-spin-icon-load"></Icon>
        </Spin>
      </div>
    </div>
    <!--无权限展示页-->
    <div v-else class="noPermissions_box">
      <h2 class="title">{{ $t('key1006756') }}</h2>
    </div>
    <!--刊登平台弹窗-->
    <publishingPlatformModal ref="publishingPlatform" @changePlatform="changePlatform"></publishingPlatformModal>
    <!--刊登店铺弹窗-->
    <selectPublishStoreModal ref="selectPublishStore"></selectPublishStoreModal>
    <!--定制我的设计弹窗-->
    <customizeMyDesignDrawer ref="customizeMyDesign"></customizeMyDesignDrawer>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import imgZoom from '@/components/layout/shopping/common/imgZoom';
import api from '@/api/';
import commonMixin from '@/components/mixin/common_mixin';
import {
  pageJump, amountHandel, isAlibabaDistributor, commonSessionStorage,
  commonLocalStorage, getBatchDeliveryAreasName, getTrialPrice,
  getShoppingPlatformData, getAllMatchingLogisticsData, getReceivingAddressData,
  _handleMultilingualFields, checkLogin, getAllCountrysData, getSetLanguages, getDataSetBatchList, getEnumList, getEnumName
} from "@/utils/common";
import imageBox from '@/components/common/imageBox';
import publishingPlatformModal from "@/components/common/publishingPlatformModal.vue";
import selectPublishStoreModal from "@/components/common/selectPublishStoreModal.vue";
import {TEMURUSSITE, BUTTONLAYOUTCONFIGURATION, MAPPINGLANGNAME, MAPPINGLANGVALUE} from "@/utils/enum";
import customizeMyDesignDrawer from "@/components/common/customizeMyDesignDrawer.vue";

export default {
  name: 'shopDetails',
  mixins: [commonMixin],
  data() {
    let v = this;
    return {
      followText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006714'),
      quality_supplier: require('@/assets/images/quality_supplier.png'),
      skilledHand_logo: require('@/assets/images/skilledHand_logo.png'),
      aliexpressChoiceLogoPath: require('@/assets/images/platform/aliexpressChoice.png'),
      temuChoiceLogoPath: require('@/assets/images/platform/temu_choice.png'),
      breadcrumbList: [],
      imgZoomList: [],
      prductId: null,
      details: null,
      sizeChartColumns: [],
      sizeChartdata: [],
      supplierInfo: {}, // 优质供应商的基本信息
      supplierTop3List: [], // 供应商销量最高3个商品
      followTalg: false,  // 是否关注供应商店铺
      ymsCategoryProductAttributeList: [],
      cacheImgIndex: 0,
      sizeImagePath: '', // 尺码图
      permissionsTalg: true, // 默认有仓库权限
      originalAttributesData: [], // 属性模板的基础数据

      newProductGoodsList: [],
      commodityDetails: {},
      inputValue: '1',
      quantityOfGoods: 1,
      optionsList: [],
      moreOptionsList: [],
      originalProductGoodsList: [],
      placeOfShipment: null,
      placeOfShipmentList: [],
      commodityInventory: 0, // 商品库存
      availableWarehousesList: [], // 当前商品的可用仓库
      shippingWarehouse: null,
      shippingWarehouseList: [],
      totalPriceOfGoods: 0,
      goodsInventoryResult: [],
      customizedProductsColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006715'),
          key: 'customizableParts',
          minWidth: 120,
          align: 'center',
          renderHeader(h, params) {
            return h('div', [
              h('i', {
                class: 'iconfont distributorThemeColor',
                domProps: {
                  innerHTML: '&#xe636;'
                }
              }),
              h('span', {class: 'ml6 font-size-13'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006715'))
            ])
          },
          render(h, params) {
            return h('span', params.row.name)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006716'),
          key: 'customizableArea',
          minWidth: 110,
          align: 'center',
          renderHeader(h, params) {
            return h('div', {class: 'flex'}, [
              h('i', {
                class: 'iconfont distributorThemeColor',
                domProps: {
                  innerHTML: '&#xe65c;'
                }
              }),
              h('div', {class: 'ml6 font-size-13'}, [
                h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006717')),
                h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006718'))
              ])
            ])
          },
          render(h, params) {
            let districtLength = params.row.districtLength;
            let districtWidth = params.row.districtWidth;
            return h('span', districtLength + ' * ' + districtWidth);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006719'),
          key: 'customizedCraftsmanship',
          minWidth: 100,
          align: 'center',
          renderHeader(h, params) {
            return h('div', [
              h('i', {
                class: 'iconfont distributorThemeColor',
                domProps: {
                  innerHTML: '&#xe652;'
                }
              }),
              h('span', {class: 'ml6 font-size-13'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006719'))
            ])
          },
          render(h, params) {
            let workmanshipType = params.row.workmanshipType;
            let name = '';
            v.customizedCraftsmanshipList.map((item) => {
              if (item.value === workmanshipType) {
                name = item.name;
              }
            });
            return h('span', name);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006720'),
          key: 'customizationFee',
          align: 'center',
          minWidth: 120,
          renderHeader(h, params) {
            return h('div', [
              h('i', {
                class: 'iconfont distributorThemeColor',
                domProps: {
                  innerHTML: '&#xe8a4;'
                }
              }),
              h('span', {class: 'ml6 font-size-13'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006720'))
            ])
          },
          render(h, params) {
            let customizationFee;
            if (v.userInfo) {
              customizationFee = params.row.customizationFee;
            } else {
              customizationFee = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006721');
            }
            return h('span', customizationFee);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006722'),
          key: 'customDescription',
          width: 180,
          renderHeader(h, params) {
            return h('div', [
              h('i', {
                class: 'iconfont distributorThemeColor',
                domProps: {
                  innerHTML: '&#xe71d;'
                }
              }),
              h('span', {class: 'ml6 font-size-13'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006722'))
            ])
          },
          render(h, params) {
            let direction = params.row.direction;
            return v.checkContentOverflow(h, direction, 180, 3)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001457'),
          key: 'locationDiagram',
          minWidth: 400,
          renderHeader(h, params) {
            return h('div', {class: 'flex align-items-center'}, [
              h('i', {
                class: 'iconfont distributorThemeColor',
                domProps: {
                  innerHTML: '&#xe609;'
                }
              }),
              h('span', {class: 'ml6 font-size-13'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001457'))
            ])
          },
          slot: 'locationDiagram'
        },
      ],
      customizedProductsData: [],
      ymsProductCategoryPositionsList: [],
      destinationCountryList: [],
      destinationValue: 'US',
      logisticsMethodData: [],
      logisticsMethods: {},
      logisticsDropdownVisible: false,
      destinationVisible: false,
      buyerPostalCode: null,
      enumData: []
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    fromListing() {
      return this.$store.state.fromListing
    },
    isAlibabaDistributor() {
      return isAlibabaDistributor()
    },
    // 是否展示商品标签
    showProductTagInMall() {
      const obj = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      return Number(obj?.enableShowProductTagInMall) === 1;
    },
    // 商品总重量
    totalWeight() {
      let quantity = Number(this.inputValue) || 0;
      return this.commodityDetails.weight * quantity;
    },
    // 是否展示售卖国
    showProductSaleCountrySet() {
      const obj = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      return Number(obj?.enableProductSaleCountrySet) === 1;
    },
    // 是否已停售状态
    isStopSale() {
      return this.details.shelveStatus === 2;
    },
    // 跨境电商平台配置
    distributorPlatformSet() {
      const obj = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      return obj?.distributorPlatformSet || [];
    },
    // 商品详情页按钮布局配置
    mallDetailsPageSettings() {
      const obj = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      return obj?.mallDetailsPageSettings || [];
    },
    // 定制工艺
    customizedCraftsmanshipList() {
      const ENUM_KEY = 'YmsProductGoodsPositionWorkmanshipTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    }
  },
  created() {
    this.$store.commit('showHover', true);
    if (this.$route.params.id) {
      this.prductId = this.$route.params.id;
    } else {
      this.gotoError();
    }
    (async () => {
      this.enumData = await getDataSetBatchList(['YmsProductGoodsPositionWorkmanshipTypeCoreEnum', 'YmsProductAttributeValueTypeCoreEnum']);
      await getReceivingAddressData().then((data) => {
        let list = data.filter(item => item.isDefault === 1);
        if (list.length > 0) {
          this.buyerPostalCode = list[0].postalCode;
        }
      });
      await getAllCountrysData().then((data) => {
        this.destinationCountryList = data;
        this.getShopDetail();
      });
    })();
  },
  methods: {
    amountHandel,
    // 获取选中的物流方式
    selectedLogisticsMethod(value) {
      this.logisticsMethods = this.logisticsMethodData.find(item => item.ymsLogisServiceId === value);
    },
    // 收藏
    subscription() {
      let v = this;
      if (!v.isStopSale) {
        checkLogin(true).then((res) => {
          let distributorMerchantId = res.merchant.merchantId;
          if (distributorMerchantId) {
            v.axios.post(api.post_ymsDistributorMerchantSubscription_subscription,
              [v.details.ymsProductId]).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005541'));
                v.getShopDetail();
                if (v.fromListing && document.referrer) {
                  window.parent.postMessage({
                    type: 'subscriptionProduct',
                    ymsProductId: v.details.ymsProductId,
                    from: 'detail',
                    status: 1
                  }, '*');
                }
              }
            });
          }
        });
      } else {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006723'));
        return false;
      }
    },
    // 取消收藏
    unSubscription() {
      let v = this;
      if (!v.isStopSale) {
        checkLogin(true).then((res) => {
          let distributorMerchantId = res.merchant.merchantId;
          if (distributorMerchantId) {
            v.axios.post(api.post_ymsDistributorMerchantSubscription_cancelSubscription,
              [v.details.ymsProductId]).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006724'));
                v.getShopDetail();
                if (v.fromListing && window.parent) {
                  window.parent.postMessage({
                    type: 'subscriptionProduct',
                    ymsProductId: v.details.ymsProductId,
                    from: 'detail',
                    status: 0
                  }, '*');
                }
              }
            });
          }
        });
      } else {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006725'));
        return false;
      }
    },
    // 获取店铺详情
    getShopDetail() {
      let v = this;
      v.imgZoomList = [];
      v.breadcrumbList = [];
      v.permissionsTalg = true;
      v.originalAttributesData = [];
      v.shippingWarehouseList = [];
      v.placeOfShipmentList = [];
      let url = '';
      if (v.userInfo.merchantId) {
        url = api.get_ymsProductInfo_shopping + this.prductId + `?distributorMerchantId=${v.userInfo.merchantId}`;
      } else {
        url = api.get_ymsProductInfo_shopping + this.prductId;
      }
      let aliexpressChoiceiconPath = null;
      getShoppingPlatformData().then((platformData) => {
        v.axios.get(url).then(response => {
          let code = response.data.code;
          if (code === 0) {
            let data = response.data.datas;
            if (data) {
              v.getItemAttributesData(data).then((attributesData) => {
                v.ymsProductCategoryPositionsList = attributesData.ymsProductCategoryPositions || [];
                v.originalAttributesData = attributesData.ymsCategoryProductAttributeList || [];
                // 刊登平台icon图标
                let availablePlatforms = data.availablePlatforms || [];
                let newList = [];
                let source = data.source;
                // 商品来源是listing
                if (source === 'listing') {
                  let platformJson = data.platformJson || '';
                  if (platformJson) {
                    v.ymsCategoryProductAttributeList = [];
                    let obj = JSON.parse(platformJson);
                    let productAttributesList = obj.listingPushPlatformInsertProductInfoBo.productAttributes || [];
                    v.ymsCategoryProductAttributeList = productAttributesList.map((item) => {
                      return {
                        name: item.platformAttributeName,
                        valueText: item.values
                      }
                    })
                  }
                }
                // 一键刊登支持的平台
                if (availablePlatforms.length > 0) {
                  availablePlatforms.map((ele) => {
                    platformData.map((item) => {
                      if (ele.platformId === item.platformId || ele.platformName === item.name || ele.platformName === item.platformId) {
                        ele.iconPath = item.logoPath;
                        if (ele.platformId === 'temu_choice') {
                          ele.iconPath = v.temuChoiceLogoPath;
                        }
                      }
                    });
                    // 速卖通全托管平台
                    if (ele.platformId === 'aliexpress') {
                      let obj = {
                        platformId: 'aliexpressChoice',
                        iconPath: v.aliexpressChoiceLogoPath
                      }
                      newList.push(obj);
                    }
                  });
                  if (v.distributorPlatformSet.length > 0) {
                    let platformList = availablePlatforms.filter(item => v.distributorPlatformSet.includes(item.platformId));
                    data.availablePlatforms = [...platformList, ...newList];
                  } else {
                    data.availablePlatforms = [];
                  }
                }
                // 商品标签
                let productTagNames = data.productTagNames || [];
                let productTagList = [];
                if (productTagNames.length > 0) {
                  productTagList = productTagNames.map(tag => {
                    let parsedTag = JSON.parse(tag);
                    return parsedTag[v.languagesVal];
                  }).filter(name => name);
                }
                data.productTagList = productTagList;
                v.details = data;
                v.handleBreadcrumbData(v.details);
                // 处理尺码图的数据
                v.sizeImagePath = '';
                let productSizeImageList = v.details.productSizeImageList;
                if (productSizeImageList && productSizeImageList.length > 0) {
                  // 默认展示ukSize的尺码图，ukSize 没有尺码图，则取cnSize的尺码图
                  let ukSizeList = productSizeImageList.filter((item) => item.languageType === 'ukSize' && item.imagePath);
                  if (ukSizeList.length > 0) {
                    v.sizeImagePath = ukSizeList[0].imagePath;
                  } else {
                    let cnSizeList = productSizeImageList.filter((item) => item.languageType === 'cnSize' && item.imagePath);
                    if (cnSizeList.length > 0) {
                      v.sizeImagePath = cnSizeList[0].imagePath;
                    }
                  }
                }
                let supplierMerchantId = v.details.supplierMerchantId;
                let ymsProductId = v.details.ymsProductId;
                if (supplierMerchantId) {
                  v.getSupplierInfo(supplierMerchantId);
                  v.getSupplierTop3(supplierMerchantId, ymsProductId);
                  v.isAssociatedStore(supplierMerchantId);
                }

                v.productServiceList.map((item) => {
                  if (item.value === v.details.productService) {
                    v.details.productServiceTxt = item.name;
                  }
                });
                if (!v.details) {
                  v.$router.push({path: '/index'});
                }
                // 处理发货地数据
                let arr = data.availableWarehouses || [];
                arr.forEach((item) => {
                  item.name = item.aliasWarehouseName || item.name;
                })
                v.availableWarehousesList = arr;
                if (v.availableWarehousesList.length > 0) {
                  let ymsDeliveryPlaceIds = v.availableWarehousesList.map(item => item.ymsDeliveryPlaceId).filter(Boolean);
                  ymsDeliveryPlaceIds = v.uniqueFunc(ymsDeliveryPlaceIds);
                  if (ymsDeliveryPlaceIds.length > 0) {
                    getBatchDeliveryAreasName(ymsDeliveryPlaceIds).then((newData) => {
                      if (newData.length > 0) {
                        v.placeOfShipmentList = newData;
                        let ymsDeliveryPlaceId = commonLocalStorage.getItem('ymsDeliveryPlaceId');
                        let talg = v.placeOfShipmentList.some((item) => item.ymsDeliveryPlaceId === ymsDeliveryPlaceId);
                        if (talg) {
                          v.placeOfShipment = ymsDeliveryPlaceId;
                        } else {
                          v.placeOfShipment = newData[0].ymsDeliveryPlaceId;
                        }
                        v.handleShipmentWarehouseData(v.placeOfShipment);
                      }
                    })
                  }
                }

                let productImageList = v.details.productImageList || [];
                let productColorImageList = v.details.productColorImageList || [];
                let new_arr = [...productImageList, ...productColorImageList];
                if (new_arr) {
                  new_arr.map(i => {
                    if (i.path) {
                      if (i.path.includes('http') || i.path.includes('https')) {
                        v.imgZoomList.push(i);
                      }
                    }
                  });
                }
                v.getOptionBtnSetData();
              });
            }
          } else if (code === 111291) {
            v.permissionsTalg = false;
          }
        });
      });
    },
    // 获取物品属性的基础数据
    getItemAttributesData(details) {
      let v = this;
      let ymsProductCategoryId = details.ymsProductCategoryId;
      let productAttributeResultList = details.productAttributeResultList || [];
      return new Promise(resolve => {
        if (ymsProductCategoryId) {
          v.axios.get(api.get_ymsProductCategory_shopping + `${ymsProductCategoryId}`).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas;
              if (data) {
                if (data.ymsCategoryProductAttributeList && data.ymsCategoryProductAttributeList.length > 0) {
                  v.ymsCategoryProductAttributeList = [];
                  // 获取商品的基础属性
                  let list = data.ymsCategoryProductAttributeList.filter(item => item.attributeType === 0);
                  let primaryAttributeList = list.map((item) => {
                    return item.ymsProductAttributeTemplate
                  });
                  // 取出所有基础属性关联的子属性
                  let associationPropertyData = [];
                  list.map((ele) => {
                    let productAttributeDictionaryBosData = ele.ymsProductAttributeTemplate.productAttributeDictionaryBos || [];
                    productAttributeDictionaryBosData.map((talg) => {
                      let ymsProductAttributeTemplates = talg.ymsProductAttributeTemplates || [];
                      ymsProductAttributeTemplates.map((k) => {
                        if (k.type === 0) {
                          k.unit = k.productAttributeDictionaryBos.length > 0 ? k.productAttributeDictionaryBos[0].ymsProductAttributeDictionaryId : null;
                        }
                      });
                      associationPropertyData.push(...ymsProductAttributeTemplates);
                    });
                  });
                  if (v.isAlibabaDistributor) {
                    function handleData(item) {
                      let values = item.values || [];
                      let valueText = [];
                      if (values.length > 0) {
                        values.map((talg) => {
                          if (talg.value) {
                            valueText.push({
                              value: talg.value,
                              proportion: talg.proportion
                            });
                          }
                        })
                      }
                      item['valueText'] = v.uniqueFunc(valueText);
                    }

                    productAttributeResultList.map((item) => {
                      primaryAttributeList.map((ele) => {
                        if (item.ymsProductAttributeTemplateId === ele.ymsProductAttributeTemplateId) {
                          item['name'] = v.languagesVal === 'zh-CN' ? ele.cnName : ele.usName;
                          handleData(item);
                        } else {
                          item['name'] = item.ymsProductAttributeTemplateId;
                          handleData(item);
                        }
                      })
                    });
                    v.ymsCategoryProductAttributeList = productAttributeResultList;
                  } else {
                    let newList = handleFunData(primaryAttributeList);
                    associationPropertyData = handleFunData(associationPropertyData);
                    newList.forEach((i, attrIndex) => {
                      let arr = [];
                      let propertyValues = i.propertyValues || [];
                      let value = propertyValues.length > 0 ? propertyValues.map((j) => j.value) : null;
                      if (Array.isArray(value)) {
                        if (associationPropertyData.length > 0) {
                          arr = associationPropertyData.filter((item) => value.includes(item.ymsProductAttributeDictionaryId));
                        }
                      } else {
                        if (associationPropertyData.length > 0) {
                          arr = associationPropertyData.filter((item) => item.ymsProductAttributeDictionaryId === value);
                        }
                      }
                      if (arr.length > 0) {
                        newList.splice(attrIndex + 1, 0, ...arr);
                      }
                    });
                    v.ymsCategoryProductAttributeList = v.uniqueFunc(newList, 'ymsProductAttributeTemplateId');

                    function handleFunData(newList) {
                      let attributeRequireArr = [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000304'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000305'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000306')];
                      let chooseTypeArr = [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000395'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000394')];
                      if (newList.length > 0) {
                        newList.map((item) => {
                          item['name'] = v.languagesVal === 'zh-CN' ? item.cnName : item.usName;
                          item['attributeRequireText'] = attributeRequireArr[item.attributeRequire];
                          let text = getEnumName(v.enumData, 'YmsProductAttributeValueTypeCoreEnum', item.type, 'number');
                          if (item.type === 1) {
                            item['typeText'] = text + '(' + chooseTypeArr[item.chooseType] + ')';
                          } else {
                            item['typeText'] = text;
                          }
                          item['propertyValues'] = null;
                          item['inputValue'] = '';
                          if (productAttributeResultList.length > 0) {
                            productAttributeResultList.forEach((ele) => {
                              if (item.ymsProductAttributeTemplateId === ele.ymsProductAttributeTemplateId) {
                                item.valueText = [];
                                let values = ele.values || [];
                                let valueText = [];
                                if (values.length > 0) {
                                  values.map((item) => {
                                    if (item.value) {
                                      valueText.push({
                                        value: item.value,
                                        proportion: item.proportion,
                                        unit: item.unit || null
                                      });
                                    }
                                  })
                                }
                                if (ele.type === 1) {
                                  item['propertyValues'] = v.uniqueFunc(valueText, 'value');
                                  item['customValues'] = []; // 自定义属性的value值
                                  if (item.productAttributeDictionaryBos) {
                                    let ymsProductAttributeDictionaryIdList = [];
                                    item.productAttributeDictionaryBos.forEach((talg) => {
                                      ymsProductAttributeDictionaryIdList.push(talg.ymsProductAttributeDictionaryId)
                                      if (item.propertyValues && item.propertyValues.length > 0) {
                                        item.propertyValues.map((k) => {
                                          if (k.value === talg.ymsProductAttributeDictionaryId) {
                                            if (v.languagesVal === 'US') {
                                              item.valueText.push({
                                                value: talg.usValue,
                                                proportion: k.proportion
                                              });
                                            } else {
                                              item.valueText.push({
                                                value: talg.cnValue,
                                                proportion: k.proportion
                                              });
                                            }
                                          }
                                        });
                                      }
                                    });
                                    // 处理自定义属性的value
                                    if (ymsProductAttributeDictionaryIdList.length > 0) {
                                      if (item.propertyValues && item.propertyValues.length > 0) {
                                        item.propertyValues.map((ele) => {
                                          if (!ymsProductAttributeDictionaryIdList.includes(ele.value)) {
                                            item['customValues'].push({
                                              value: ele.value,
                                              proportion: ele.proportion
                                            })
                                          }
                                        });
                                        let valuesList = [...item.valueText, ...item.customValues];
                                        item.valueText = valuesList;
                                      }
                                    }
                                  }
                                } else {
                                  item['valueText'] = v.uniqueFunc(valueText);
                                }
                              }
                            });
                          }
                        });
                      }
                      return newList;
                    }
                  }
                }
                resolve(data);
              }
            }
          });
        }
      });
    },
    // 处理属性值百分比
    handleAttributeProportion(proportion) {
      let value = Number(proportion) || 0;
      let val = (value * 100).toFixed(2);
      if (val % 1 === 0) {
        val = val.slice(0, -3);
      }
      return val;
    },
    // 处理属性单位
    handleattributeUnit(item, unit) {
      let unitName = '';
      let productAttributeDictionaryBos = item.productAttributeDictionaryBos || [];
      productAttributeDictionaryBos.map((ele) => {
        if (ele.ymsProductAttributeDictionaryId === unit) {
          unitName = ele.cnValue;
        }
      });
      return unitName;
    },
    // 重置数据
    resetDetail() {
      this.details = null;
      this.tableData = [];
      this.imgZoomList = [];
      this.newProductGoodsList = [];
      this.commodityDetails = {};
    },
    // 进入店铺
    toStoreList() {
      let lang = getSetLanguages();
      let ymsDeliveryPlaceId = commonLocalStorage.getItem('ymsDeliveryPlaceId');
      if (this.fromListing) {
        window.location.href = this.supplierInfo.supplierSecondLevelDomain + `?lang=${lang}&ymsDeliveryPlaceId=${ymsDeliveryPlaceId}`;
      } else {
        window.open(this.supplierInfo.supplierSecondLevelDomain + `?lang=${lang}&ymsDeliveryPlaceId=${ymsDeliveryPlaceId}`, '_blank');
      }
    },
    // 关注店铺
    followStore() {
      let v = this;
      checkLogin(true).then((res) => {
        let distributorMerchantId = res.merchant.merchantId;
        if (distributorMerchantId) {
          if (!v.followTalg) {
            let query = `?ymsDistributorMerchantId=${distributorMerchantId}&ymsSupplierMerchantId=${v.details.supplierMerchantId}`;
            v.axios.post(api.post_ymsSupplierMerchant_addAssociatedStore + query).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
                v.getShopDetail();
                v.followText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006726');
              }
            });
          }
        }
      });
    },
    // 查询当前当前供应商店铺是否被关注
    isAssociatedStore(supplierMerchantId) {
      let v = this;
      let query = `?ymsDistributorMerchantId=${v.userInfo.merchantId}&ymsSupplierMerchantId=${supplierMerchantId}`;
      v.axios.get(api.get_ymsSupplierMerchant_isAssociatedStore + query).then(response => {
        if (response.data.code === 0) {
          v.followTalg = response.data.datas;
          v.followText = v.followTalg ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006726') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006714');
        }
      });
    },
    // 获取供应商基本信息数据
    getSupplierInfo(supplierMerchantId) {
      let v = this;
      let talg = true;
      v.supplierInfo = {};
      let ymsProductIdList = [];
      // 判断当前商品是否参加活动且开启展示供应商信息
      let activitiesList = commonSessionStorage.getItem('ongoingActivitiesData') || [];
      if (activitiesList.length > 0) {
        activitiesList.map((item) => {
          let ymsProductIds = item.ymsProductIds || [];
          ymsProductIdList.push(...ymsProductIds);
        });
        // 不参加活动的商品，要默认展示供应商信息
        if (ymsProductIdList.length > 0) {
          if (!ymsProductIdList.includes(v.prductId)) {
            talg = true;
          } else {
            talg = false;
            activitiesList.map((item) => {
              let ymsProductIds = item.ymsProductIds || [];
              if (ymsProductIds.includes(v.prductId)) {
                if (item.isShowSupplierInfo === 1) {
                  talg = true;
                }
              }
            });
          }
        }
      }
      if (talg) {
        v.axios.get(api.get_ymsSupplierMerchant + supplierMerchantId).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              let newData = data.ymsSupplierMerchantDetail || {};
              newData = Object.assign({}, data, newData);
              newData.name = _handleMultilingualFields(data.name);
              v.$store.commit('supplierInfo', newData);
              let arr = ['name', 'address'];
              arr.map((item) => {
                if (newData[item] === null) {
                  newData[item] = '';
                }
              });
              v.supplierInfo = newData;
              // 判断是否有美西仓库
              let ymsSupplierAscriptionWarehouses = data.ymsSupplierAscriptionWarehouses || [];
              v.usWestWarehouseTalg = ymsSupplierAscriptionWarehouses.some(item => item.code === 'US001');
            }
          }
        });
      } else {
        v.supplierInfo = {};
      }
    },
    // 获取供应商销量最高3个商品
    getSupplierTop3(supplierMerchantId, ymsProductId) {
      let v = this;
      v.supplierTop3List = [];
      let query = {
        orderBy: 'totalSoldQuantity', // 总销量
        supplierMerchantId: supplierMerchantId,
        activityStatus: 0, // 活动状态 0无 1清仓 2促销 3热卖
        pageNum: 1,
        pageSize: 4
      };
      let countryCode = v.showProductSaleCountrySet ? (commonLocalStorage.getItem('sellingCountry') || 'CN') : 'CN';
      let ymsDeliveryPlaceId = commonLocalStorage.getItem('ymsDeliveryPlaceId');
      let dataList = [];
      if (v.userInfo.merchantId) {
        query.distributorMerchantId = v.userInfo.merchantId;
      }
      if (v.showProductSaleCountrySet) {
        query.countryCode = countryCode;
      }
      if (ymsDeliveryPlaceId) {
        query.ymsDeliveryPlaceId = ymsDeliveryPlaceId;
      }
      v.axios.post(api.post_ymsProductInfo_shopping_query, query).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          let list = data.list || [];
          if (list.length > 0) {
            list.map((item) => {
              if (item.ymsProductId !== ymsProductId) {
                dataList.push(item);
              }
            });
            v.supplierTop3List = dataList.slice(0, 3).map(i => {
              i.orgin_minSuggestPrice = i.minSuggestPrice;
              return i;
            });
          }
        }
      });
    },
    // 查看销量最高的商品详情
    toshopDetails(data) {
      const {href} = this.$router.resolve({
        path: `/shopDetails/${data.ymsProductId}`
      });
      if (this.fromListing) {
        this.resetDetail();
        this.prductId = data.ymsProductId;
        this.getShopDetail();
      } else {
        window.open(href, '_blank');
      }
    },
    // 选择刊登平台之后
    changePlatform(data) {
      let type = 0;
      if (this.$store.state.erpConfig) {
        type = this.$store.state.erpConfig.merchant.listingStatus === '1' ? 1 : 0; // 刊登类型 0:YMS上架工具 1:通途刊登系统
      }
      this.$refs['selectPublishStore'].initSelectPublishStoreData(data, this.details.ymsProductId, type);
    },
    // 处理面包屑的路径
    changeBreadcrumb(data) {
      let path = '';
      if (!data.talg) {
        path = `/shopList?ymsProductCategoryId=${data.ymsProductCategoryId}`
      } else {
        path = data.path;
      }
      return path;
    },
    // 处理面包屑的数据
    handleBreadcrumbData(data) {
      let v = this;
      v.breadcrumbList = [];
      let obj = {path: '/index', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006562'), talg: true};
      let ymsClassifyList = commonLocalStorage.getItem('classificationData') || v.$store.state.classificationData;
      let ymsProductCategoryIds = [];
      if (ymsClassifyList && ymsClassifyList.length > 0) {
        function treeToList(tree, list = []) {
          tree.forEach(node => {
            list.push(node)
            node.children && treeToList(node.children, list)
          })
          return list
        }

        let originalData = treeToList(ymsClassifyList);
        // 获取当前分类的数据
        let newList = originalData.filter((item) => {
          if (item.ymsProductCategoryId === data.ymsProductCategoryId) {
            return item;
          }
        });
        if (newList.length > 0) {

          function handleData(list) {
            originalData.map((ele) => {
              list.map((item) => {
                if (item.parentCode === ele.productCategoryCode) {
                  ymsProductCategoryIds.unshift(ele.ymsProductCategoryId);
                  handleData([ele]);
                }
              });
            });
          }

          handleData(newList)

          ymsProductCategoryIds = [...ymsProductCategoryIds, data.ymsProductCategoryId];
          ymsProductCategoryIds.forEach(i => {
            originalData.forEach(j => {
              if (i === j.ymsProductCategoryId) {
                j.title = j.name;
                v.breadcrumbList.push(j);
              }
            });
          });
        }
      } else {
        let arr = data.productCategoryNavigation ? data.productCategoryNavigation.split('->') : [];
        if (arr.length > 0) {
          arr.map((item) => {
            v.breadcrumbList.push({
              title: item,
              talg: true,
              path: null
            });
          });
        }
      }
      v.breadcrumbList.unshift(obj);
    },
    // 选择规格
    selectSpecifications(type, idx, index, obj) {
      let v = this;
      if (obj.isDisabled) return;
      switch (type) {
        case 'primaryAttribute':
          v.$set(v.newProductGoodsList[idx], 'currentIndex', index);
          v.$set(v.newProductGoodsList[idx], 'selectValue', obj.value);
          // 自动切换左侧轮播图
          v.imgZoomList.forEach((item, ids) => {
            if (item.path === obj.imgPath) {
              v.$refs['imgBox'].selectImg(item, ids);
            }
          });
          handleData();
          break;
        case 'current':
          v.$set(v.newProductGoodsList[idx], 'currentIndex', index);
          v.$set(v.newProductGoodsList[idx], 'selectValue', obj.value);
          handleData();
          break;
      }

      function handleData() {
        setTimeout(() => {
          let specificationsValueList = [];
          v.newProductGoodsList = v.handleSpecValueId(v.newProductGoodsList);
          v.newProductGoodsList.map((item) => {
            specificationsValueList.push(item.name + ':' + item.selectValue);
          });
          let targetId = specificationsValueList.join('_');
          v.originalProductGoodsList.map((item) => {
            if (item.specificationsValueId === targetId) {
              let {ymsSku, weight, availableNumber, ymsAvailableNumber, usWestNumber, ...vals} = item;
              v.commodityDetails = {
                ...vals,
                ymsSku,
                weight,
                availableNumber: availableNumber || 0,
                ymsAvailableNumber: ymsAvailableNumber || 0,
                usWestNumber: usWestNumber || 0
              }
              if (v.goodsInventoryResult.length > 0) {
                v.commodityInventory = 0;
                v.goodsInventoryResult.map((ele) => {
                  if (ele.ymsSku === ymsSku) {
                    v.commodityInventory = ele.availableNumber;
                  }
                })
              }
            }
          });
          v.getCommodityPrice();
        }, 200);
      }
    },
    // 加减数量按钮
    quantityBtn(type) {
      const maxQty = this.commodityInventory || 0; // 最大库存
      if (type === 'add') {
        if (this.quantityOfGoods < maxQty) {
          this.quantityOfGoods++;
          this.inputValue = String(this.quantityOfGoods);
          this.getCommodityPrice();
        }
      } else if (type === 'minus') {
        if (this.quantityOfGoods > 1) {
          this.quantityOfGoods--;
          this.inputValue = String(this.quantityOfGoods);
          this.getCommodityPrice();
        }
      }
    },
    // 选择数量
    validateInput() {
      let val = this.inputValue.replace(/\D/g, '') || '1';
      if (val === '0') val = '1';
      // 控制最大库存限制
      const maxQty = this.commodityInventory || 0;
      let numericVal = +val;
      if (numericVal > maxQty) {
        numericVal = maxQty;
        this.inputValue = String(maxQty);
      } else {
        this.inputValue = val;
      }

      this.quantityOfGoods = numericVal;
      this.getCommodityPrice();
    },
    // 获取操作按钮的配置
    getOptionBtnSetData() {
      let {availablePlatforms, shelveStatus, hasPermission} = this.details;
      let userInfoTalg = Object.keys(this.userInfo).length > 0;
      let obj = {
        // 一键刊登
        publish: (availablePlatforms && availablePlatforms.length > 0 &&
            this.getPermission('ymsDistributorProductInfo_publish') && userInfoTalg) ||
          (availablePlatforms && availablePlatforms.length > 0 && !userInfoTalg) || this.fromListing,
        // 定制我的设计
        customizeMyDesign: (this.details.isSupportCustomization === 1 && userInfoTalg &&
          this.getPermission('ymsDistributorProductInfo_createCustomizationGoods')) || !userInfoTalg,
        // 妙手采集
        masteryCollection: TEMURUSSITE !== window.location.origin,
        // 生成售卖资料
        sellingMaterials: userInfoTalg,
        // 下载资料
        downloadMaterials: shelveStatus === 1 && hasPermission && ((this.getPermission('ymsDistributorProductInfo_download')
          && userInfoTalg) || !userInfoTalg) && !this.fromListing,
        // 立即购买
        buyNow: true,
        // 加入购物车
        shoppingCart: true,
      }
      this.mallDetailsPageSettings.map((item) => {
        let showTalg = obj[item.paramKey] || false;
        item.showBtn = item.isItVisible && showTalg;
      });
      let newList = this.mallDetailsPageSettings.filter((item) => item.showBtn === true);
      if (newList.length > 0) {
        let length = newList.length > 4 ? 3 : 4;
        newList.map((ele) => {
          BUTTONLAYOUTCONFIGURATION.map((talg) => {
            if (ele.paramKey === talg.paramKey) {
              ele.buttonName = talg.buttonName;
            }
          })
        });
        this.optionsList = newList.slice(0, length);
        this.moreOptionsList = newList.slice(length);
      }
      this.$forceUpdate();
    },
    // 操作按钮
    optionsBtn(item) {
      let paramKey = item.paramKey;
      let {availablePlatforms, source, platformJson, ymsProductCategoryId, ymsProductId} = this.details;
      switch (paramKey) {
        // 一键刊登
        case 'publish':
          let availablePlatformsList = availablePlatforms.filter((item) => {
            return item.platformId !== 'aliexpressChoice'
          });
          if (source === 'listing') {
            if (platformJson) {
              let obj = JSON.parse(platformJson);
              let platformIds = obj.platformIds || [];
              this.$refs['publishingPlatform'].initPublishingPlatformData(platformIds, ymsProductCategoryId, source);
            }
          } else {
            this.$refs['publishingPlatform'].initPublishingPlatformData(availablePlatformsList, ymsProductCategoryId);
          }
          break;
        // 定制我的设计
        case'customizeMyDesign':
          this.customizedButton();
          break;
        // 妙手采集
        case'masteryCollection':
          const currentUrl = encodeURIComponent(window.location.href);
          const targetUrl = `https://erp.91miaoshou.com/api/home/home/go_ap_item?apItemUrl=${currentUrl}&utm_source=ymsshopping`;
          window.open(targetUrl, '_blank');
          break;
        // 生成售卖资料
        case'sellingMaterials':
          let type = 0;
          if (this.$store.state.erpConfig) {
            type = this.$store.state.erpConfig.merchant.listingStatus === '1' ? 1 : 0; // 刊登类型 0:YMS上架工具 1:通途刊登系统
          }
          this.generateSalesInfoFun('single', ymsProductId, this.userInfo.merchantId, type);
          break;
        // 下载资料
        case'downloadMaterials':
          checkLogin(true).then((res) => {
            let distributorMerchantId = res.merchant.merchantId;
            if (distributorMerchantId) {
              let query = {
                commodityPictures: ["carousel", "attribute", "sizeTable"],
                isCommodityInformation: 1,
                ymsProductIds: [ymsProductId]
              }
              this.axios.post(api.post_ymsDistributorProductInfo_download, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
                if (response.data.code === 0) {
                  let taskNumber = response.data.datas;
                  setTimeout(() => {
                    pageJump('/distributor.html#/exportTask?operateCode=' + taskNumber, '/yms-distributor-service', '_blank');
                  }, 30)
                }
              });
            }
          });
          break;
        // 立即购买
        case'buyNow':
          if (this.commodityInventory > 0) {
            checkLogin(true).then(() => {
              const {href} = this.$router.resolve({
                path: '/mallOrderSubmission',
                query: {
                  operationType: 'buyNow'
                }
              });
              let specificationAttributeList = [];
              this.newProductGoodsList.map((item) => {
                specificationAttributeList.push({
                  name: item.name,
                  value: item.selectValue
                })
              })
              let obj = Object.assign({}, this.commodityDetails);
              obj.quantity = Number(this.inputValue);
              obj.specificationAttributeList = specificationAttributeList;

              obj.ymsSpu = this.details.ymsSpu;
              obj.ymsProductId = this.prductId;
              obj.ymsProductCategoryId = ymsProductCategoryId;
              obj.ymsWarehouseId = this.shippingWarehouse;
              commonLocalStorage.setItem('commodityDetails', obj);
              setTimeout(() => {
                window.open(href, '_blank');
              }, 800);
            });
          } else {
            this.$Modal.warning({
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000330'),
              content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006727'),
              okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000248')
            });
          }
          break;
        // 加入购物车
        case'shoppingCart':
          checkLogin(true).then(() => {
            this.addToCart();
          });
          break;
      }
    },
    // 更多操作按钮
    moreOptionsBtn(name) {
      this.moreOptionsList.map((item) => {
        if (item.paramKey === name) {
          this.optionsBtn(item);
        }
      })
    },
    // 定制设计按钮
    customizedButton() {
      checkLogin(true).then((res) => {
        this.$refs['customizeMyDesign'].initCustomizeMyDesignData('customDesign', null, this.details);
      });
    },
    // 加入购物车
    addToCart() {
      let obj = Object.assign({}, this.commodityDetails);
      let query = {
        quantity: Number(this.inputValue),
        ymsProductGoodsId: obj.ymsProductGoodsId
      }
      this.axios.post(api.post_ymsProductCart_insertProductCart, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((response) => {
        if (response.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006728'));
        }
      });
    },
    // 处理发货仓数据
    handleShipmentWarehouseData(value) {
      this.shippingWarehouseList = [];
      let newList = this.availableWarehousesList.filter((item) => item.ymsDeliveryPlaceId === value);
      if (newList.length > 0) {
        newList.map((item) => {
          let ymsWarehouseDeliverySettings = item.ymsWarehouseDeliverySettings || [];
          item['warehouseType'] = (item.isDeliveryWarehouse === 1 && ymsWarehouseDeliverySettings.length > 0) ? 3 : 1;
        });
        this.shippingWarehouseList = newList;
        if (newList.length > 0) {
          this.shippingWarehouse = newList[0].ymsWarehouseId;
          this.shippingWarehouseChange(this.shippingWarehouse);
        }
      }
    },
    // 切换发货地
    deliveryLocationChange(value) {
      this.handleShipmentWarehouseData(value);
    },
    // 切换发货仓
    shippingWarehouseChange(value) {
      this.commodityInventory = 0;
      this.goodsInventoryResult = [];
      let warehouseType = this.shippingWarehouseList.filter((item) => item.ymsWarehouseId === value)[0].warehouseType;
      let query = {
        warehouseType: warehouseType, // 1 中心仓 2 美西仓 3 供应商(三方)
        ymsProductId: this.details.ymsProductId,
        ymsWarehouseId: value
      };
      if (!this.isStopSale) {
        this.axios.post(api.post_ymsProductInfo_shopping_inventoryDetail, query,
          {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((res) => {
          if (res.data.code === 0) {
            let data = res.data.datas;
            if (data) {
              this.goodsInventoryResult = data.goodsInventoryResult || [];
              this.handleSpecificationData(this.details, this.goodsInventoryResult)
              this.getDestinationLogisticsChannel(value, this.destinationValue);
            }
          }
        });
      }
    },
    // 获取当前商品在指定仓库下的价格
    getCommodityPrice() {
      const v = this;
      if (Object.keys(v.userInfo).length > 0) {
        setTimeout(() => {
          let {ymsProductGoodsId} = v.commodityDetails;
          let query = {
            priceTrialGoodsBoList: [{
              quantity: Number(v.inputValue),
              ymsProductGoodsId: ymsProductGoodsId,
              isNeedCustomization: 0,
            }],
            ymsDistributorMerchantId: v.userInfo.merchantId,
            warehouseIds: [v.shippingWarehouse],
          }
          v.totalPriceOfGoods = 0;
          getTrialPrice(query).then((newData) => {
            if (newData.length > 0) {
              newData.map((item) => {
                if (item.warehouseId === v.shippingWarehouse) {
                  v.totalPriceOfGoods = amountHandel(item.goodsPrice);
                }
              });
              v.$forceUpdate();
            }
          });
        }, 700);
      }
    },
    // 获取目的地对应的所有物流渠道信息
    getDestinationLogisticsChannel(ymsWarehouseId, countryCode) {
      let logisticsData = [];
      let query = {
        warehouseIds: [ymsWarehouseId],
        countryCode: countryCode
      };
      getAllMatchingLogisticsData(query).then((newData) => {
        newData.map((item) => {
          if (item.ymsWarehouseId === ymsWarehouseId) {
            item.logisticsData.map((ele) => {
              if (ele.key !== 'distributorEnableCarrier') {
                logisticsData.push(...ele.list);
              }
            });
          }
        });
        logisticsData.map((item) => {
          item.estimateFreightPrice = '-';
          item.postalCodeData = [];
        })
        this.logisticsMethodData = logisticsData;
        this.logisticsMethods = logisticsData[0] || {};
        this.getLogisticsFee(ymsWarehouseId, countryCode);
      })
    },
    // 计算当前指定目的地下所有的物流渠道运费
    getLogisticsFee(ymsWarehouseId, countryCode) {
      let list = [];
      let {ymsProductGoodsId, ymsSku} = this.commodityDetails;
      if (this.logisticsMethodData.length > 0) {
        this.logisticsMethodData.map((item) => {
          let {carrierMerchantType, shippingMethodId, merchantId, ymsLogisServiceId} = item;
          list.push({
            countryCode: countryCode,
            priceTrialGoodsBoList: [
              {
                quantity: Number(this.inputValue),
                ymsProductGoodsId: ymsProductGoodsId,
                isNeedCustomization: 0,
                ymsSku: ymsSku,
              }
            ],
            shippingMethodId: carrierMerchantType === 3 ? null : shippingMethodId,
            ymsDistributorMerchantId: this.userInfo.merchantId,
            ymsLogisServiceId: carrierMerchantType === 3 ? ymsLogisServiceId : null,
            buyerPostalCode: this.buyerPostalCode,
            carrierMerchantType: carrierMerchantType,
            carrierMerchantId: carrierMerchantType === 1 ? merchantId : null,
            warehouseIds: [ymsWarehouseId]
          })
        });
        if (list.length > 0) {
          this.axios.post(api.post_ymsProductInfo_api_priceTrials + '?fresh=KEEPNEW', list).then(response => {
            if (response.data.code === 0) {
              const newData = response.data.datas || [];
              this.logisticsMethodData.forEach(ele => {
                const key = ele.carrierMerchantType === 1 ? 'shippingMethodId' : ele.carrierMerchantType === 3 ? 'ymsLogisServiceId' : null;
                if (!key) return;
                const matched = newData.find(item => item[key] === ele[key]);
                if (matched) {
                  ele.estimateFreightPrice = matched.estimateFreightPrice;
                  ele.freightSortValue = matched.estimateFreightPrice;
                  const map = matched.postalCodeEstimateFreightMap || {};
                  if (Object.keys(map).length) {
                    let arr = Object.entries(map).map(([postalCode, shippingCost]) => ({
                      postalCode,
                      shippingCost: amountHandel(shippingCost),
                      expand: false
                    }));
                    arr.sort((a, b) => b.shippingCost - a.shippingCost);
                    arr.map((item, idx) => {
                      item.expand = idx === 0;
                    });
                    ele.postalCodeData = arr;
                    let maxShippingCost = 0;
                    if (arr.length > 0) {
                      maxShippingCost = Math.max(...arr.map(item => item.shippingCost));
                      ele.freightSortValue = maxShippingCost;
                    }
                  } else {
                    ele.postalCodeData = [];
                  }
                }
              });
              this.logisticsMethodData.sort((a, b) => a.freightSortValue - b.freightSortValue);
              this.$forceUpdate();
            }
          });
        }
      }
    },
    // 切换目的地
    destinationChange(value) {
      if (value) {
        this.getDestinationLogisticsChannel(this.shippingWarehouse, value);
      }
    },
    // 显示物流方式
    logisticsMethodVisibleChange(visible) {
      this.logisticsDropdownVisible = visible;
    },
    // 显示目的地
    destinationVisibleChange(visible) {
      this.destinationVisible = visible;
    },
    // 展开与收起
    logisticsMethodExpand() {
      this.logisticsMethods.postalCodeData.map((item) => {
        item.expand = !item.expand;
      });
      this.$forceUpdate();
    },
    // 处理规格数据
    handleSpecificationData(data, goodsInventoryResult) {
      let specificationData = this.originalAttributesData.filter((item) => item.attributeType === 1);
      let newProductGoodsList = [];
      // 在售spu
      let productGoodsList = [];
      if (data.shelveStatus === 1) {
        productGoodsList = (data.productGoodsList || []).filter((item) => item.status === 1);
      } else {
        productGoodsList = data.productGoodsList || [];
      }
      const inventoryMap = new Map(goodsInventoryResult.map(i => [i.ymsSku, i.availableNumber]));
      productGoodsList.forEach(item => {
        const stock = inventoryMap.get(item.ymsSku);
        item.isDisabled = stock === undefined || stock <= 0;
      });
      let groupedAll = {};
      productGoodsList.forEach(item => {
        if (item.status === 1) {
          item.orgin_suggestPrice = item.suggestPrice;
        }
        let priceFields = [
          {value: item.activityPriceValue, field: 'activityPriceValue'},
          {value: item.suggestPrice, field: 'suggestPrice'}
        ]
        if (item.freightDiscount !== 1) {
          priceFields.push({value: item.freightDiscountPrice, field: 'freightDiscountPrice'})
        }
        let newPriceFields = priceFields.filter(price => price.value != null)
        const minPrice = Math.min(...newPriceFields.map(price => price.value));
        item.price = amountHandel(minPrice);
        let {productGoodsSpecifications, ...obj} = item;
        let specs = item.productGoodsSpecifications || [];
        // 处理属性值、属性名多语种映射
        specs.map((k) => {
          k.name = k.multilingual ? (k.multilingual[MAPPINGLANGNAME[this.languagesVal]] || k.name) : k.name;
          k.value = k.multilingual ? (k.multilingual[MAPPINGLANGVALUE[this.languagesVal]] || k.value) : k.value;
        });
        let imgPath = (item.productGoodsImages || [])[0] ? item.productGoodsImages[0].path : null;
        let specificationsValue = [];
        specs.forEach(spec => {
          if (!groupedAll[spec.name]) {
            groupedAll[spec.name] = [];
          }
          if (!groupedAll[spec.name].some(s => s.value === spec.value)) {
            groupedAll[spec.name].push({
              ...spec,
              imgPath: imgPath,
              productGoods: obj
            });
          }
          specificationsValue.push(spec.name + ':' + spec.value)
        });
        item.specificationsValueId = specificationsValue.join('_');
      });
      let productGoodsSpecificationsList = productGoodsList.filter((item) => !item.isDisabled)[0]?.productGoodsSpecifications;
      this.originalProductGoodsList = productGoodsList;
      Object.keys(groupedAll).forEach(key => {
        newProductGoodsList.push({
          currentIndex: 0,
          name: key,
          selectValue: groupedAll[key][0].value,
          values: groupedAll[key]
        });
      });
      if (newProductGoodsList.length > 0) {
        newProductGoodsList.map((item) => {
          specificationData.map((ele) => {
            let name = ele.ymsProductAttributeTemplate?.[MAPPINGLANGNAME[this.languagesVal]];
            if (item.name === name) {
              item.isMainAttribute = ele.isMainAttribute;
            }
          });
          productGoodsSpecificationsList.map((k) => {
            if (item.name === k.name) {
              item.selectValue = k.value;
            }
          })
        });
        let name = productGoodsSpecificationsList[0]?.name;

        let info = null;
        newProductGoodsList.map((item) => {
          if (item.name === name) {
            let vlaue = item.selectValue;
            info = item.values.find(s => s.value === vlaue);
          }
        });
        let obj = info.productGoods;
        let {availableNumber, ymsAvailableNumber, usWestNumber, ...vals} = obj;
        this.commodityDetails = Object.assign({}, {
          ...vals,
          availableNumber: availableNumber || 0,
          ymsAvailableNumber: ymsAvailableNumber || 0,
          usWestNumber: usWestNumber || 0,
        });
        goodsInventoryResult.map((item) => {
          if (item.ymsSku === this.commodityDetails.ymsSku) {
            this.commodityInventory = item.availableNumber;
          }
        });
        this.newProductGoodsList = this.handleSpecValueId(newProductGoodsList);
        this.getCommodityPrice();
      }
    },
    // 生成 specificationsValueId（只基于主属性）
    handleSpecValueId(list) {
      if (!Array.isArray(list) || !list.length) return list;
      const selectedMap = list.reduce((acc, item) => {
        acc[item.name] = item.selectValue;
        return acc;
      }, {});
      const disabledMap = new Map((this.originalProductGoodsList || []).map(i => [i.specificationsValueId, i.isDisabled]));
      list.forEach(spec => {
        spec.values.forEach(val => {
          const specId = Object.keys(selectedMap).map(key => `${key}:${key === spec.name ? val.value : selectedMap[key]}`).join('_');
          this.$set(val, 'specificationsValueId', specId);
          // 无对应在售 SKU 的规格组合不可选（含已过滤的停售 SKU）
          val.isDisabled = disabledMap.has(specId) ? disabledMap.get(specId) : true;
        });
      });
      return list;
    }
  },
  watch: {
    commodityDetails: {
      handler(data) {
        let ymsProductGoodsPositionsList = data.ymsProductGoodsPositions || [];
        let customizationChargingMode = data.customizationChargingMode;
        if (ymsProductGoodsPositionsList.length > 0) {
          ymsProductGoodsPositionsList.map((item) => {
            this.ymsProductCategoryPositionsList.map((ele) => {
              if (item.ymsProductCategoryPositionId === ele.ymsProductCategoryPositionId) {
                item.name = _handleMultilingualFields(ele.parts);
              }
            });
            if (customizationChargingMode === 1) {
              item.customizationFee = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006729');
            }
            if (customizationChargingMode === 2) {
              item.customizationFee = ymsProductGoodsPositionsList[0].price.toFixed(2) + ' ' + this.currencyState;
            }
            if (customizationChargingMode === 3) {
              item.customizationFee = item.price.toFixed(2) + ' ' + this.currencyState;
            }
          })
        }
        this.customizedProductsData = ymsProductGoodsPositionsList;
      },
      deep: true,
      immediate: true,
    }
  },
  beforeDestroy() {
    let dom = document.getElementsByClassName('mouse-cover-canvas');
    if (dom) {
      for (let i = 0; i < dom.length; i++) {
        dom[i].style.display = 'none';
      }
    }
  },
  components: {
    imgZoom,
    imageBox,
    publishingPlatformModal,
    selectPublishStoreModal,
    customizeMyDesignDrawer
  }
};
</script>

<style>
.ivu-table td.size-column {
  background-color: #ff6600 !important;
  color: #fff;
}
</style>
<style lang="less" scoped>
@import "src/assets/styles/shopping/common";

.desc-box {
  border: 1px solid #EEEEEE;
  padding: 15px 20px;
  margin: 20px;

  .desc-box-item {
    display: flex;
    flex-wrap: wrap;
    font-size: 15px;
    margin-bottom: 10px;

    .desc-box-item-title {
      color: #000;
      font-weight: bold;
    }

    .desc-box-content {
      color: #666;
      flex: 1;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
  }
}

.desc-box-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.shopdetails-box {
  width: 1200px;
  margin: 0 auto;
  min-height: 400px;

  .breadcrumb_box {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;

    .breadcrumb_title {
      font-size: 14px;
      font-family: 'PingFangSC-Regular';
      color: #000;
      opacity: 0.5;
    }

    /deep/ .ivu-breadcrumb-item-separator {
      color: #515a6e;
      margin: 0 4px 0 0;
    }
  }

  .exhibition-box {
    background-color: #fff;
    padding: 20px;
    min-height: 512px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;

    .exhibition-left {
      width: 380px;
    }

    .exhibition-right {
      width: 750px;

      .exhibition-title {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #1D1D1D;
      }

      .productTag_item {
        display: inline-block;
        padding: 2px 8px;
        font-size: 12px;
        color: #fff;
        background-color: #FD5425;
        margin: 0 0 8px 10px;
        max-width: 204px;
        text-overflow: ellipsis;
        white-space: nowrap;
        border-radius: 4px;
        overflow: hidden;
      }

      .grounding-box {
        display: flex;
        align-items: center;
        margin: 10px 0;

        .text, .trsText {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: @subject_color;
          margin-right: 40px;
        }

        .trsText {
          color: #6EAF39;
        }
      }

      .shippingWarehouse_box {
        display: flex;
        flex-wrap: wrap;
        max-width: 650px;

        .shippingWarehouse_item {
          margin: 0 25px 12px 0;
          display: flex;
          align-items: center;
        }

        /deep/ .ivu-radio-wrapper {
          font-size: 12px;
        }
      }

      .opts-box {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }

      .support_platform_content {
        .title {
          font-size: 13px;
          color: #333;
          font-weight: bold;
          margin: 20px 0 8px 0;
        }

        .support_platform_box {
          display: flex;
          flex-wrap: wrap;

          .platformIcon {
            margin-bottom: 8px;
            display: flex;
            align-items: center;
            margin-right: 12px;

            .support_platform_item {
              width: 55px;
              height: 30px;
              background-color: #F2F2F2;
              border-radius: 4px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
      }

      .subscribe-btn, .more-subscribe-btn {
        min-width: 140px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        cursor: pointer;
        margin-right: 13px;
        border-radius: 1px;
      }

      .more-subscribe-btn {
        min-width: 90px;
      }

      .specificationImage_box {
        width: 80px;
        height: 80px;
        border: 1px solid #F4F4F4;
        overflow: hidden;
        border-radius: 4px;
        cursor: pointer;
        margin: 4px 15px 10px 0;
        position: relative;

        .img_style_item {
          left: 50%;
          max-height: 100%;
          max-width: 100%;
          position: absolute;
          top: 50%;
          transform: translateY(-50%) translateX(-50%);
        }

        &:hover {
          border: 2px solid #FD5425;
        }
      }

      .specificationValue_box {
        min-width: 50px;
        display: inline-block;
        text-align: center;
        border: 2px solid #F4F4F4;
        overflow: hidden;
        border-radius: 4px;
        cursor: pointer;
        margin: 0 15px 10px 0;
        font-size: 13px;
        padding: 3px 8px;
        box-sizing: border-box;

        &:hover {
          border: 2px solid #FD5425;
          color: #FD5425;
        }
      }

      .specification_active {
        border: 2px solid #FD5425;
        color: #FD5425;
      }

      .specificationImageDisabled, .specificationValueDisabled {
        cursor: not-allowed;
        background-color: #FFF;
        opacity: 0.3;

        &:hover {
          border: 2px solid transparent;
          color: #666;
        }
      }

      .quantityOfGoods_box {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin: 0 10px 0 5px;
        width: 130px;
        height: 30px;
        border: 1px solid #E6E6E6;
        border-radius: 30px;
        overflow: hidden;

        .quantity_input_box {
          width: 55px;
          display: inline-block;
          height: 30px;
          line-height: 29px;
          text-align: center;
          font-size: 14px;
        }

        .quantity_btn {
          font-weight: bold;
          color: #333;
          cursor: pointer;
          font-size: 18px;
          padding: 0 10px;
        }
      }

      .price_box {
        margin-bottom: 15px;

        .amount {
          color: #FF4400;
          font-size: 36px;
          font-weight: bold;
        }

        .currency {
          color: #FD5425;
          font-size: 14px;
          margin-left: 6px;
          vertical-align: text-bottom;
        }
      }
    }
  }

  .shopping-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .shop-content-nav {
      width: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 50px;

      .quality-supplier-box {
        width: 100%;
        background-color: #fff;
        padding-bottom: 15px;
        margin-bottom: 15px;

        .title-box {
          width: 202px;
          height: 50px;
          background-image: url("../../../../assets/images/quality_supplier.png");
          background-repeat: no-repeat;
          background-position: -1px -1px;
          background-size: cover;
          display: flex;
          align-items: center;
          justify-content: center;

          .title {
            font-size: 17px;
            font-weight: bold;
            margin-left: 16px;
            color: #C2973F;
          }

          .set_title {
            font-weight: bold;
            color: #C2973F;
            font-size: 12px;
            margin-left: 50px;
          }
        }

        .supplier-title {
          margin: 12px auto 15px;
          font-size: 13px;
          color: #1D1D1D;
          font-weight: bold;
          .ellipsis(1);
          padding: 0 16px;
        }

        .line-item {
          color: #777777;
          font-size: 13px;
          margin-bottom: 12px;
          padding: 0 16px;
        }

        .options-btn {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 20px;
          padding: 0 16px;

          .btn {
            color: #5C5C5C;
            font-size: 13px;
            height: 30px;
            line-height: 30px;

            &:hover {
              color: #fff;
              background-color: #FD5425;
            }
          }

          .ivu-btn[disabled] {
            background-color: #f7f7f7;
            border-color: #dcdee2;
            color: #c5c8ce;
          }
        }
      }

      .top3-box-item {
        cursor: pointer;
        width: 200px;
        padding: 15px;
        background-color: #fff;
        border: 1px solid transparent;
        box-sizing: border-box;
        position: relative;

        .img-style {
          width: 170px;
          height: 170px;
          overflow: hidden;
        }

        .title {
          font-family: PingFang SC;
          color: #333;
          font-size: 14px;
          text-align: center;
          .ellipsis(1);
          margin: 10px auto;
        }

        .text {
          text-align: center;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #FD5425;
        }

        .original_price_style {
          color: #8D8D8D;
          text-decoration: line-through;
          padding-left: 10px;
          font-size: 12px;
          font-weight: normal;
        }

        &:hover {
          border: 1px solid @subject_color;
          box-sizing: border-box;
        }
      }
    }

    .shop-details-box {
      width: 985px;
      background-color: #fff;
      margin-bottom: 50px;

      .shop-details-title {
        height: 50px;
        line-height: 50px;
        padding-left: 19px;
        border-bottom: 1px solid #EEEEEE;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #1D1D1D;
        box-sizing: border-box;
      }

      .shop-details-center {
        text-align: left;
        padding: 10px 0px;
        min-height: 35px;
        background-color: #fff;
        white-space: pre-line; /* 添加此行以支持换行显示 */

        /deep/ img, /deep/ table {
          display: block;
          width: 100% !important;
          height: auto;
        }

        /deep/ p img {
          display: inline-block;
          width: 100% !important;
          height: auto;
        }
      }

      .size-chart-box {
        .szieImage {
          width: 100%;
          height: auto;
          display: block;
        }
      }
    }
  }

  .shop-details-box-hide {
    visibility: hidden;
  }

  .noPermissions_box {
    width: 100%;
    min-height: 490px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    margin-bottom: 15px;

    .title {
      color: #333;
      font-size: 14px;
      padding-top: 150px;
    }
  }

  .customDesign_btn {
    position: absolute;
    top: 33px;
    right: 34px;
    color: #FD5425;
    cursor: pointer;
    text-decoration: underline;
  }
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

.center-align {
  padding-bottom: 30px;
}

.discount {
  width: 730px;
  display: flex;
  background-color: #F5F5F5;
  padding: 5px 12px 12px 12px;
  margin-bottom: 15px;

  .dis-box {
    margin-right: 50px;
  }

  .d-item {
    height: 40px;
    display: flex;
    align-items: center;

    .ic {
      font-size: 22px;
      color: #FD5425;
    }

    .icon {
      font-size: 18px;
      margin-left: 5px;
      color: #FD5425;
    }
  }
}

.imgagesList_box {
  display: flex;
  flex-wrap: wrap;
  margin: 8px 0;

  .imgagesList_box_item {
    margin: 0 6px 0 0;

    .img_content {
      position: relative;
      cursor: pointer;
      width: 70px;
      height: 70px;
    }

    .img-styles {
      width: 70px;
      height: 70px;
      object-fit: cover;
      border: 1px solid #ddd;
    }
  }
}

.logisticsMethod_box, .destination_box {
  display: flex;
  flex-direction: column;
  background-color: #F8F8F8;
  padding: 8px 15px 15px 15px;
  cursor: pointer;
  position: relative;
  border: 1px solid #ECECEC;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);

  .title {
    color: #949494;
    font-size: 14px;
  }

  /deep/ .ivu-select-dropdown {
    position: absolute !important;
    /*top: 75px !important;*/
    background-color: #F8F8F8;
    max-height: 300px;
    overflow-y: auto;

    .ivu-dropdown-menu {
      padding: 0 7px;
    }

    .logisticsMethod_box_item {
      padding: 12px;
      border-bottom: 1px solid #E7E7E7;

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .setlabelName {
    font-size: 14px;
    color: #333;
    width: 200px;
  }

  .postalCodeStyle {
    max-width: 152px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    position: relative;
    top: 3px;
  }

  .smallDot {
    content: ' ';
    display: inline-block;
    margin-left: 10px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #00B42A;
  }

  .labelTxt {
    max-width: 165px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.logisticsMethod_box {
  border-left: none;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.destination_box {
  padding-left: 0;

  /deep/ .ivu-select-selection {
    height: inherit !important;
    border-radius: initial !important;
    border: none !important;
    background-color: #F8F8F8 !important;
    box-shadow: none !important;

    .ivu-select-prefix {
      padding: 0 !important;
      width: 100%;
    }

    .ivu-select-input {
      height: 21px !important;
      line-height: inherit !important;
      padding: 0 10px 0 15px !important;
      color: #333 !important;
      font-size: 14px !important;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ivu-select-head-flex {
      flex-direction: column;
    }

    .ivu-select-arrow {
      display: none !important;
    }
  }
}
</style>
